export default __webpack_public_path__ + "static/media/104.9da8d2fe.webp";